export default (palette, typography) => ({
  fontFamily: typography.fontFamily,
  fontColor: palette.grey.G600,
  toggleBackgroundColor: 'transparent',
  toggleBorderColor: palette.grey.G400,
  selectedBorderColor: palette.grey.G300,
  selectedBackgroundColor: palette.grey.G200,
  disabledTextColor: palette.text.dark,
  disabledBackgroundColor: palette.grey.G200,
  disabledBorderColor: palette.grey.G400,
  outlineReplacement: `inset 0 0 3px 2px ${palette.outline}`,
  addButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: palette.primary.normal,
    borderRadius: 0,
    padding: 2,

    '&:hover, &:focus': {
      backgroundColor: 'transparent',
      border: 'none'
    }
  },
  weeklyButtons: {
    borderRadius: 30,
    width: 37,
    height: 37,
    padding: [10, 9],
    margin: [0, 10, 0, 0],
    '&:first-child': {
      marginLeft: 0
    },
    '&:last-child': {
      marginRight: 0
    },
    borderColor: palette.grey.G300,
    backgroundColor: palette.grey.G50,
    color: palette.grey.G500,
    '&:hover, &:focus': {
      backgroundColor: palette.grey.G50
    }
  },
  weeklyActiveButtons: {
    backgroundColor: palette.primary.normal,
    borderColor: palette.primary.normal,
    color: palette.text.light,
    '&:hover, &:focus': {
      backgroundColor: palette.primary.normal,
      borderColor: palette.primary.normal
    }
  },
  addBtnText: {
    marginLeft: 10,
    position: 'relative',
    top: -1
  }
});
